// Responses to chat messages generated by the Nut API.

import type { Message } from './message';
import type { AppEvent } from './appEvent';

interface ChatResponseBase {
  chatId: string | undefined;
  time: string;
}

// A piece of a message in a chat response.
interface ChatResponseMessage extends ChatResponseBase {
  kind: 'message';
  message: Message;
}

// A suggested title for the chat triggering the Nut run.
interface ChatResponseTitle extends ChatResponseBase {
  kind: 'title';
  title: string;
}

// A status message generated by Nut.
interface ChatResponseStatus extends ChatResponseBase {
  kind: 'status';
  status: string;
}

// Progress was made while developing the app.
interface ChatResponseAppEvent extends ChatResponseBase {
  kind: 'app-event';
  event: AppEvent;

  // Total number of peanuts spent on the chat so far.
  peanuts?: number;
}

// Generated when the chat message has an error.
interface ChatResponseError extends ChatResponseBase {
  kind: 'error';
  error: any;
}

// Generated when the chat message finished normally.
interface ChatResponseDone extends ChatResponseBase {
  kind: 'done';
}

// Generated when the chat message is aborted.
interface ChatResponseAborted extends ChatResponseBase {
  kind: 'aborted';
}

// Responses to a chat message produced by a Nut run.
export type ChatResponse =
  | ChatResponseMessage
  | ChatResponseTitle
  | ChatResponseStatus
  | ChatResponseAppEvent
  | ChatResponseError
  | ChatResponseDone
  | ChatResponseAborted;

// Whether a response indicates the associated worker has finished.
export function isWorkerFinishedResponse(response: ChatResponse): boolean {
  switch (response.kind) {
    case 'done':
    case 'error':
    case 'aborted':
      return true;
  }
  return false;
}
